// extracted by mini-css-extract-plugin
export default {"technicalAspectsContainer":"technicalAspects_technicalAspectsContainer__vqMPP","section":"technicalAspects_section__sR0DZ"};